import { createContext, useContext } from "react";

// Lets custom nodes (rendered inside ReactFlow) trigger Builder actions —
// e.g. the "+" leg that adds the next node from a given output handle.
export const BuilderActionsContext = createContext({
  onAddAfter: () => {},
  onIterateList: null,
  onOpenTemplates: () => {},
  onRunManual: () => {},
  // canvas vazio: as duas formas de começar. onOpenCopilot vem null quando o
  // copiloto está desligado — aí o card mostra só "Adicionar gatilho".
  onPickTrigger: () => {},
  onOpenCopilot: null,
  // id do nó que está executando neste instante (destaque pulsante no canvas)
  nodeRodando: null,
});

export const useBuilderActions = () => useContext(BuilderActionsContext);
